import React, { Component } from 'react';
import EveryVisualizer from './EveryVisualizer.js';
import CheckboxParameter from './CheckboxParameter.js';
import Dropdown from 'react-dropdown';
import ConditionedComponent from 'components/ConditionedComponent.js';
import ParameterizerEffectComponent from './ParameterizerEffectComponent.js'; 
import EffectParameterSlider from './EffectParameterSlider.js';
import {setContextualHelp} from "actions/index.js";
import {PARAMETERIZER_FACTOR} from 'constants/contextual-help.js';
import {PARAMETERIZER_OFFSET} from 'constants/contextual-help.js';
import {PARAMETERIZER_DROPDOWN} from 'constants/contextual-help.js';
import {PROBABILITY} from 'constants/contextual-help.js';
import { connect } from "react-redux";

class EveryEffectComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    addParameter() {
        this.props.effect.newParameter();
        this.setState(this.state);
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.props.effect.isEnabled();
    }

    getParameterOptions() {
        let parameters = this.props.effect
            .getAvailableParameters();

        return parameters.map(
            p => ({
                label: p.name,
                value: p}));
    }

    getParameterOption(o) {
        if (o === undefined) {
            return undefined;
        }
        let filtered = this.getParameterOptions().filter(
            x => x.value === o);

        return filtered.length > 0 ? filtered[0] : undefined;
    }

    handleParameterChange(p) {
        this.props.effect.parameter = p.value;
        this.setState(this.state);
    }

    setContextualHelp(e, contextualHelp) {
        e.stopPropagation();
        this.props.setContextualHelp(contextualHelp);
    }

    deleteParameterizer(effect) {
        this.props.effect.deleteParameterizer(effect);
        this.setState(this.state);
    }

    render() {
        return (
            <div>
              <ConditionedComponent condition={this.isEnabled()}>
                <EffectParameterSlider
                  effectNumber={this.props.effectNumber}
                  name={'Every'}
                  contextualHelp={PROBABILITY}
                  unit={"th trigger"}
                  automation={this.props.automation}
                  parameter={this.props.effect.everyParameter}
                  onParameterChanged={this.props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  step={1}
                  min={1}
                  max={16}/>
                <EffectParameterSlider
                  effectNumber={this.props.effectNumber}
                  name={'Trigger Offset'}
                  contextualHelp={PROBABILITY}
                  unit={"th trigger"}
                  automation={this.props.automation}
                  parameter={this.props.effect.offsetParameter}
                  onParameterChanged={this.props.onParameterChanged}
                  isParameter={true}
                  sequencerEngine={this.props.sequencerEngine}
                  lfoEnabled={true}
                  step={1}
                  min={0}
                  max={8}/>
                <EveryVisualizer
                  effect={this.props.effect}
                  sequencerEngine={this.props.sequencerEngine}/>
           {this.props.effect.parameterEffects.map(
                effect =>
                    <ParameterizerEffectComponent
                      isSimple={true}
                      deleteParameterizer={(effect) => this.deleteParameterizer(effect)}
                      effect={effect}
                      sequencerEngine={this.props.sequencerEngine}/>
            )}
                                                                                        
                <div
                  onClick={() => this.addParameter()}
                  className="add-parameterizer-button">
                  Add Parameter
                </div>
              </ConditionedComponent>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
    };
}
 
export default connect(null, mapDispatchToProps)(EveryEffectComponent);
